import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";
import logoImage from "../../../src/assets/img/logo/logo.png";
import logoBSC from "../../../src/assets/img/icon/bsc.png";
import logoPulse from "../../../src/assets/img/icon/pulse.png";
import logoEthereum from "../../../src/assets/img/icon/ethereum.png";
import logoPolygon from "../../../src/assets/img/icon/polygon.png";
import $ from "jquery";
import { scrollToTop } from "../../lib/helpers";
import { handleClickScroll } from "../../lib/helpers";

const Header = () => {
  // sticky nav bar
  const [stickyClass, setStickyClass] = useState({
    fixed: "",
    header: "",
  });

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      // window height changed for the demo
      windowHeight < 245
        ? setStickyClass({ fixed: "", header: "" })
        : setStickyClass({ fixed: "active-height", header: "sticky-menu" });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);
    return () => window.removeEventListener("scroll", stickNavbar);
  }, []);

  // mobile menu
  useEffect(() => {
    //SubMenu Dropdown Toggle
    if ($(".menu-area li.menu-item-has-children ul").length) {
      $(".menu-area .navigation li.menu-item-has-children").append(
        '<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>'
      );
    }

    //Mobile Nav Hide Show
    if ($(".mobile-menu").length) {
      let mobileMenuContent = $(".menu-area .main-menu").html();
      $(".mobile-menu .menu-box .menu-outer").append(mobileMenuContent);

      //Dropdown Button
      $(".mobile-menu li.menu-item-has-children .dropdown-btn").on(
        "click",
        function () {
          $(this).toggleClass("open");
          $(this).prev("ul").slideToggle(500);
        }
      );
      //Menu Toggle Btn
      $(".mobile-nav-toggler").on("click", function () {
        $("body").addClass("mobile-menu-visible");
      });

      //Menu Toggle Btn
      $(".menu-backdrop, .mobile-menu .close-btn").on("click", function () {
        $("body").removeClass("mobile-menu-visible");
      });
    }
  }, []);

  // active link switching
  const { hash, pathname } = useLocation();
  const isActiveLink = (id) => {
    return id == hash ? "active" : "";
  };

  
  return (
    <header id="header">
      <div id="header-fixed-height" className={cn(stickyClass.fixed)} />

      <div id="sticky-header" className={cn("menu-area", stickyClass.header)}>
        <div className={cn("container custom-container")}>
          <div className="row">
            <div className="col-12">
              <div className={"mobile-nav-toggler"}>
                <i className="fas fa-bars" />
              </div>

              <div className="menu-wrap">
                <nav className={"menu-nav"}>
                  <div className="logo">
                    <Link to={"/"}>
                      <img src={logoImage} alt="TheSoulCol Logo" />
                    </Link>
                  </div>

                  <div className={cn("navbar-wrap main-menu d-none d-lg-flex")}>
                    <ul>
                      <li>
                        <Link to="" className={"section-link"} onClick={() => scrollToTop()}>
                          PRESALE
                        </Link>
                      </li>
                      <li>
                        <Link to="" className={"section-link"} onClick={() => handleClickScroll("dex")}>
                          DEX
                        </Link>                      
                      </li>
                      <li>
                        <Link to="" className={"section-link"} onClick={() => handleClickScroll("staking")}>
                          STAKING
                        </Link>
                      </li>                      
                      <li>
                        <Link to=""  className={"section-link"} onClick={() => handleClickScroll("nft")}>
                          SOUL MINT
                        </Link>
                      </li>            
                      <li>
                        <Link to=""  className={"section-link"} onClick={() => handleClickScroll("bridge")}>
                          BRIDGE
                        </Link>
                      </li>
                      <li>
                        <Link to=""  className={"section-link"} onClick={() => handleClickScroll("tldr")}>
                          TLDR;
                        </Link>
                      </li>                      
                   </ul>
                  </div>
                  <div className={cn("header-action", "d-none d-md-block")}>
                    <div className="footer-content container visible-lg-block">
                      <ul className="footer-social container">
                      <li>
                        <a href="https://t.me/SoulFi_net" target="_blank">
                          <i className="fab fa-telegram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://x.com/TheSoulFi" target="_blank">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>                    
                      <li>
                        <a href="https://github.com/TheSoulCollection" target="_blank">
                          <i className="fab fa-github"></i>
                        </a>
                      </li>
                      </ul>
                    </div>
                    </div>
                  <div>
                    <Link to={"/"}>
                      <img src={logoPolygon} alt="Polygon Chain Logo" />
                    </Link>
                    &nbsp;
                    <Link to={"/"}>
                      <img src={logoPulse} alt="Pulse Chain Logo" />
                    </Link>
                    &nbsp;
                    <Link to={"/"}>
                      <img src={logoEthereum} alt="Ethereum Chain Logo" />
                    </Link>
                    &nbsp;
                    <Link to={"/"}>
                      <img src={logoBSC} alt="Binance Smart Chain Logo" />
                    </Link>
                    &nbsp;
                  </div>
                  <div className={cn("header-action", "d-none d-md-block")}>
                    <ul>
                      <li className="header-btn">
                        <button className="btn" onClick={scrollToTop}>
                          Buy Now
                        </button>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>

              {/* <!-- Mobile Menu  --> */}
              <div className={"mobile-menu"}>
                <nav className={"menu-box"}>
                  <div className={"close-btn"}>
                    <i className="fas fa-times"></i>
                  </div>
                  <div className={"nav-logo"}>
                    <Link to="/">
                      <img src={logoImage} alt="The Soul Collection" title="" />
                    </Link>
                  </div>

                  <div className={"menu-outer"}>
                    {/* <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header-->  */}
                  </div>

                  <div className={"social-links"}>
                    <ul className="clearfix">
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>

              <div className={"menu-backdrop"} />
              {/* <!-- End Mobile Menu --> */}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
